import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as XLSX from 'xlsx';
import { environment } from 'src/environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { interval } from 'rxjs';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-license-aas',
  templateUrl: './license-aas.component.html',
  styleUrls: ['./license-aas.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LicenseAASComponent implements OnInit {

  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  isShownError2: boolean = true;
  isShownSuccess2: boolean = true;
  isShownError3: boolean = true;
  isShownSuccess3: boolean = true;
  Status: boolean = false;
  ErrorMsg: string;
  SuccessMsg: string;
  isShownSaveBtn: boolean = false;
  isShownUpdateBtn: boolean = true;
  isShownActive: Boolean = true;
  isShownadBtn: Boolean = false;
  isShownupdBtn: Boolean = true;
  isShownadBtn1: Boolean = false;
  isShownupdBtn1: Boolean = true;
  imageurl: string;
  LicType: string;
  LicenseNumber: string;
  LicenseDate: string;
  ValidFrom: string;
  ValidTo: string;
  LicCurrency: string;
  LicValue: string;
  LicFobValueForeign:string;
  LicCifValueINR:string;
  LicCifValueForeign:string;
  ExpItemNo: string;
  ExportRitc: string;
  ExpItemName: string;
  ExpQuantity: string;
  ExpUOM: string;
  ExpFobInr: string;
  ExpFobForgn: string;
  ImpItemNo: string;
  ImpRitc: string;
  ImpItemName: string;
  ImpBOMquantity: string;
  ImpUOM: string;
  ImpQuantity: string;
  ImpCIFvalue: string;
  ImpROQ: string;
  ImpUtilQty: string;
  ImpCurrentStatus: string;
  ImpDutyAmount:string;
  ImpCIFvalueForeign:string;
  Description: string;
  Parts = [] as any;
  AdmCurrency = [] as any;
  LicItems = [] as any;
  LicImport = [] as any;
  myFiles: string[] = [];
  surl: string;
  isShownimage: boolean = true;
  selects = [] as any;
  isShowndoclist: boolean = true;
  public searchText: string;
  licenseExport = [] as any;
  Editedlicense = [] as any;
  EditedlicenseId: string;
  Editedlicensetype: string;
  EditedlicenseExport = [] as any;
  EditedlicenseExportId: string;
  EditedlicenseImport = [] as any;
  EditedlicenseImportId: string;
  updatedocid = [] as any;
  EditedDoc = [] as any;
  slicId: string;
  crntstatus: string;
  sExpId: string;
  licenseaasExport = [] as any;
  ExptNo: string;
  sOnboardingId: string;

  @ViewChild('file')
  myInputVariable: ElementRef;

  displayedColumns1: string[] = ['sno', 'type', 'number', 'licenseDate1', 'validFrom1', 'validTo1', 'currency', 'value', 'status'];
  dataSource1: MatTableDataSource<any[]>;
  @ViewChild('paginator1', { static: true }) paginator1: MatPaginator;
  @ViewChild('sort1', { static: true }) sort1: MatSort;
  @ViewChild('TABLE1') table2: ElementRef;

  displayedColumnsItem: string[] = ['itemnum', 'ritc', 'itemName', 'quantity', 'uom', 'fobvalue', 'fobforeign'];
  dataSourceItem: MatTableDataSource<any[]>;
  @ViewChild('TableItemPaginator', { static: true }) tableItemPaginator: MatPaginator;
  @ViewChild('TableItemSort', { static: true }) tableItemSort: MatSort;
  @ViewChild('TABLE1') table1: ElementRef;
  
  displayedColumnsItem1: string[] = [ 'licenseExportNo', 'itemnum', 'ritc', 'itemName', 'quantity','bomqty', 'uom','impDutyAmount','impCIFvalueForeign','cifvalue', 'roq', 'utilQty'];
  dataSourceItem1: MatTableDataSource<any[]>;
  @ViewChild('TableItemPaginator1', { static: true }) tableItemPaginator1: MatPaginator;
  @ViewChild('TableItemSort1', { static: true }) tableItemSort1: MatSort;
  @ViewChild('TABLE3') table3: ElementRef;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.ImpDutyAmount="0";
    this.ImpUtilQty="0";
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
    }
    this.BindCurrencyDDL();
    this.BindLicenseGrid();
    this.BindlicenseExport();
    this.ExptNo = "0";
    this.ExpUOM="NUM";
    this.ImpUOM="NUM";

    interval(3000).subscribe(x => {
     
    this.BindLicenseGrid();
    this.BindlicenseExport();
    });
  }
  ngAfterViewInit(): void {   
    //this.dataSource.paginator = this.paginator;
  }

  BindCurrencyDDL() {
    var value = this.http.get(environment.apiUrl + 'LicenseAdm/GetCurrencyForDDL').toPromise().then(
      (data: any) => {
       //debugger;
        if (data.length != 0) {
          this.AdmCurrency = data;
        }
        else {

        };
      });
  }

  public uploadFile = (files) => {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";

   //debugger;
    if (files.length == 0) {
      return;
    }
    for (var i = 0; i < files.length; i++) {
      this.myFiles.push(files[i]);
    }
    const formData = new FormData();
    for (var i = 0; i < this.myFiles.length; i++) {
      formData.append("file[]", this.myFiles[i]);
    }
    this.http.post(environment.apiUrl + 'LicenseAdm/UploadContent', formData).subscribe(
      (response) => {
       //debugger;
        alert(response);
      },
      (error) => {
       //debugger;
        var vDataError = JSON.stringify(error.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        this.surl = vErrorMsg1;
        var spliturl = vErrorMsg1.split(",");
        for (var i = 0; i < spliturl.length; i++) {
          this.isShownimage = false;
          this.isShowndoclist = false;
          var furl = spliturl[i];
          var cvname = furl.split("/");
          var fname = cvname[7];
          this.selects.push({ filename: fname, fileURL: furl });
          this.imageurl = furl;
          this.isShownSuccess = false;
          this.SuccessMsg = "File Uploaded"
          this.myFiles = [];
          this.myInputVariable.nativeElement.value = "";
        }
      }
    )

  }


  btnExpAddClick() {
    this.isShownError3 = true;
    this.isShownSuccess3 = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";

    if (this.ExpItemNo == undefined || this.ExpItemNo == null || this.ExpItemNo == "") {
      this.isShownError3 = false;
      this.ErrorMsg = "Please Enter Export Item Number.";
      return false;
    }
    if (this.ExportRitc == undefined || this.ExportRitc == null || this.ExportRitc == "" || this.ExportRitc == "0") {
      this.isShownError3 = false;
      this.ErrorMsg = "Please Enter Export RITC Code.";
      return false;
    }
    if (this.ExpItemName == undefined || this.ExpItemName == null || this.ExpItemName == "") {
      this.isShownError3 = false;
      this.ErrorMsg = "Please Enter Export Item Name.";
      return false;
    }
    if (this.ExpQuantity == undefined || this.ExpQuantity == null || this.ExpQuantity == "") {
      this.isShownError3 = false;
      this.ErrorMsg = "Please Enter Export Quantity.";
      return false;
    }
    if (this.ExpUOM == undefined || this.ExpUOM == null || this.ExpUOM == "") {
      this.isShownError3 = false;
      this.ErrorMsg = "Please Enter Export UOM.";
      return false;
    }
    if (this.ExpFobInr == undefined || this.ExpFobInr == null || this.ExpFobInr == "") {
      this.isShownError3 = false;
      this.ErrorMsg = "Please Enter Export FOB(INR).";
      return false;
    }
    if (this.ExpFobForgn == undefined || this.ExpFobForgn == null || this.ExpFobForgn == "") {
      this.isShownError3 = false;
      this.ErrorMsg = "Please Enter Export FOB Foreign.";
      return false;
    }

    var vUnitPrice = this.ExpFobInr;
    if (Number(vUnitPrice) < 1) {
      this.isShownError3 = false;
      this.ErrorMsg = "Please Enter Valid Export Fob(INR).";
      return false;
    }
    var vItemQuantity = this.ExpQuantity;
    if (Number(vItemQuantity) < 1) {
      this.isShownError3 = false;
      this.ErrorMsg = "Please Enter Valid Export Item Quantity.";
      return false;
    }

   //debugger;
    var editedlicId = this.EditedlicenseId;
    if (editedlicId != undefined && editedlicId != "0" && editedlicId != null) {
      var vExpItemNo = this.ExpItemNo;
      var vExportRitc = this.ExportRitc;
      var vExpItemName = this.ExpItemName;
      var vExpQuantity = this.ExpQuantity;
      var vExpUOM = this.ExpUOM;
      var vExpFobInr = this.ExpFobInr;
      var vExpFobForgn = this.ExpFobForgn;
      var vExptNo = this.ExpItemNo;
      let params4 = new HttpParams();
      params4 = params4.append('slicId', editedlicId);
      params4 = params4.append('nitemnum', vExpItemNo);
      params4 = params4.append('nritc', vExportRitc);
      params4 = params4.append('nItemname', vExpItemName);
      params4 = params4.append('nQty', vExpQuantity);
      params4 = params4.append('nuom', vExpUOM);
      params4 = params4.append('nfobInr', vExpFobInr);
      params4 = params4.append('nfobforgn', vExpFobForgn);
      params4 = params4.append('sExptNo', vExptNo);
     //debugger;
      var value = this.http.get(environment.apiUrl + 'LicenseAdm/InsertLicenseExport', { params: params4 }).toPromise().then(
        (data: any) => {
          var vmsg = data;
          this.BindLicensepartGrid();
          this.btnexportclear();
        }).catch((data: any) => {
          var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Exist") {
          this.isShownError = false;
          this.ErrorMsg = "Parent Item Number Already Exist.";
          return false;
        }
        else{
          var vmsg = data;
          this.BindLicensepartGrid();
          this.btnexportclear();
        }
        });

    }
    else {
     //debugger;
      var licensexpart = this.LicItems;
      var vExpItemNo = this.ExpItemNo;
      for (var i = 0; i < licensexpart.length; i++) {
        var vlicense = licensexpart[i];
        var vitemnum = vlicense.itemnum;
        if(vExpItemNo==vitemnum)
        {
          this.isShownError = false;
          this.ErrorMsg = "Parent Item Number Already Exist.";
          return false;
        }
      }
      this.LicItems.push({ itemnum: this.ExpItemNo, ritc: this.ExportRitc, itemName: this.ExpItemName, quantity: this.ExpQuantity, uom: this.ExpUOM, fobvalue: this.ExpFobInr, fobforeign: this.ExpFobForgn, licenseExpId: this.EditedlicenseExportId });
      this.ExptNo = "0";
     //debugger;
      this.dataSourceItem = new MatTableDataSource(this.LicItems);
      this.dataSourceItem.data = this.LicItems;
      this.dataSourceItem.paginator = this.tableItemPaginator;
      this.dataSourceItem.sort = this.tableItemSort;
    }
    this.ExpItemNo = "";
    this.ExportRitc = "";
    this.ExpItemName = "";
    this.ExpQuantity = "";
    this.ExpUOM = "NUM";
    this.ExpFobInr = "";
    this.ExpFobForgn = "";
    this.isShownError3 = true;
  }

  btnImpAddClick() {
    this.isShownError2 = true;
    this.isShownSuccess2 = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";

    if (this.ExptNo == undefined || this.ExptNo == null || this.ExptNo == "" || this.ExptNo == "0") {
      this.isShownError2 = false;
      this.ErrorMsg = "Please Enter Export Item Number.";
      return false;
    }

    if (this.ImpItemNo == undefined || this.ImpItemNo == null || this.ImpItemNo == "") {
      this.isShownError2 = false;
      this.ErrorMsg = "Please Enter Import Item Number.";
      return false;
    }
    if (this.ImpRitc == undefined || this.ImpRitc == null || this.ImpRitc == "" || this.ImpRitc == "0") {
      this.isShownError2 = false;
      this.ErrorMsg = "Please Enter Import RITC Code.";
      return false;
    }
    if (this.ImpItemName == undefined || this.ImpItemName == null || this.ImpItemName == "") {
      this.isShownError2 = false;
      this.ErrorMsg = "Please Enter Import Item Name.";
      return false;
    }
    if (this.ImpBOMquantity == undefined || this.ImpBOMquantity == null || this.ImpBOMquantity == "") {
      this.isShownError2 = false;
      this.ErrorMsg = "Please Enter Import BOM Quantity.";
      return false;
    }
    
    if (this.ImpQuantity == undefined || this.ImpQuantity == null || this.ImpQuantity == "") {
      this.isShownError2 = false;
      this.ErrorMsg = "Please Enter Import Quantity.";
      return false;
    }
    if (this.ImpUOM == undefined || this.ImpUOM == null || this.ImpUOM == "") {
      this.isShownError2 = false;
      this.ErrorMsg = "Please Enter Import UOM.";
      return false;
    }
    if (this.ImpCIFvalue == undefined || this.ImpCIFvalue == null || this.ImpCIFvalue == "") {
      this.isShownError2 = false;
      this.ErrorMsg = "Please Enter Import CIF value INR.";
      return false;
    }
    //debugger;
    var vImpROQ=this.ImpROQ.toString();
    if (vImpROQ == undefined || vImpROQ == null || vImpROQ == "") {      
      this.isShownError2 = false;
      this.ErrorMsg = "Please Enter ROQ.";
      return false;
    }
    // if (this.ImpDutyAmount == undefined || this.ImpDutyAmount == null || this.ImpDutyAmount == "") {
    //   this.isShownError2 = false;
    //   this.ErrorMsg = "Please Enter Duty Amount.";
    //   return false;
    // }
    if (this.ImpCIFvalueForeign == undefined || this.ImpCIFvalueForeign == null || this.ImpCIFvalueForeign == "") {
      this.isShownError2 = false;
      this.ErrorMsg = "Please Enter CIF Value Foreign.";
      return false;
    }
    // if (this.ImpUtilQty == undefined || this.ImpUtilQty == null || this.ImpUtilQty == "") {
    //   this.isShownError2 = false;
    //   this.ErrorMsg = "Please Enter Utilized Quantity.";
    //   return false;
    // }

   //debugger;
    var editedlicId = this.EditedlicenseId;
    if (editedlicId != undefined && editedlicId != "0" && editedlicId != null) {
      var vImpItemNo = this.ImpItemNo;
      var vImpRitc = this.ImpRitc;
      var vImpItemName = this.ImpItemName;
      var vImpBOMquantity = this.ImpBOMquantity;
      var vImpQuantity = this.ImpQuantity;
      var vImpUOM = this.ImpUOM;
      var vImpCIFvalue = this.ImpCIFvalue;
      var vImpROQ = this.ImpROQ;
      var vImpUtilQty = this.ImpUtilQty;
      var vImpDutyAmount = this.ImpDutyAmount;
      var vImpCIFvalueForeign = this.ImpCIFvalueForeign;
      var vExptNo=this.ExptNo;
      let params4 = new HttpParams();
      params4 = params4.append('mlicId', editedlicId);
      params4 = params4.append('sitemnum', vImpItemNo);
      params4 = params4.append('sritc', vImpRitc);
      params4 = params4.append('sItemname', vImpItemName);
      params4 = params4.append('sBomQty', vImpBOMquantity);
      params4 = params4.append('sqty', vImpQuantity);
      params4 = params4.append('suom', vImpUOM);
      params4 = params4.append('scifvalue', vImpCIFvalue);
      params4 = params4.append('sroq', vImpROQ);
      params4 = params4.append('sutilqty', vImpUtilQty);
      params4 = params4.append('sExptNo', vExptNo);
      params4 = params4.append('dImpDutyAmount', vImpDutyAmount);
      params4 = params4.append('dImpCIFvalueForeign', vImpCIFvalueForeign);
     //debugger;
      var value = this.http.get(environment.apiUrl + 'LicenseAdm/InsertLicenseImport', { params: params4 }).toPromise().then(
        (data: any) => {
          var vmsg = data;
          this.BindLicenseImportGrid();
          this.btnimppartclear();
        }).catch((data: any) => {
          var vmsg = data;
          this.BindLicenseImportGrid();
          this.btnimppartclear();
        });

    }
    else {
     //debugger;
      this.LicImport.push({ itemnum: this.ImpItemNo, ritc: this.ImpRitc, itemName: this.ImpItemName, bomqty: this.ImpBOMquantity,  quantity: this.ImpQuantity, uom: this.ImpUOM, cifvalue: this.ImpCIFvalue, roq: this.ImpROQ, utilQty: this.ImpUtilQty, licenseExpId: this.EditedlicenseExportId, licenseExportNo: this.ExptNo,ImpDutyAmount:this.ImpDutyAmount,ImpCIFvalueForeign:this.ImpCIFvalueForeign });
     //debugger;
      this.dataSourceItem1 = new MatTableDataSource(this.LicImport);
      this.dataSourceItem1.data = this.LicImport;
      this.dataSourceItem1.paginator = this.tableItemPaginator1;
      this.dataSourceItem1.sort = this.tableItemSort1;
    }
    this.ImpItemNo = "";
    this.ImpRitc = "";
    this.ImpItemName = "";
    this.ImpBOMquantity = "";
    this.ImpQuantity = "";
    this.ImpUOM = "NUM";
    this.ImpCIFvalue = "";
    this.ImpROQ = "";
    this.ImpUtilQty = "0";
    this.ImpDutyAmount="0";
    this.ExptNo="0";
    this.isShownError2 = true;
  }

  SaveLicenseInfo() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      return false;
    }
    if (this.LicenseNumber == undefined || this.LicenseNumber == null || this.LicenseNumber == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter License Number.";
      return false;
    }
    if (this.LicenseDate == undefined || this.LicenseDate == null || this.LicenseDate == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter License Date.";
      return false;
    }
    if (this.ValidFrom == undefined || this.ValidFrom == null || this.ValidFrom == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid From.";
      return false;
    }
    if (this.ValidTo == undefined || this.ValidTo == null || this.ValidTo == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid To.";
      return false;
    }
    if (this.ValidFrom > this.ValidTo) {
      this.isShownError = false;
      this.ErrorMsg = "Valid To Date Should be Geater Then or EqualTo Valid From Date.";
      return false;
    }
    if (this.LicCurrency == undefined || this.LicCurrency == null || this.LicCurrency == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Currency.";
      return false;
    }
    if (this.LicValue == undefined || this.LicValue == null || this.LicValue == "" || this.LicValue == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter FOB Value (INR).";
      return false;
    }
    var vVal = this.LicValue;
    if (Number(vVal) < 1) {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter FOB Value (INR).";
      return false;
    }
    if (this.LicFobValueForeign == undefined || this.LicFobValueForeign == null || this.LicFobValueForeign == "" || this.LicFobValueForeign == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter FOB Value (Foreign).";
      return false;
    }
    var vVal = this.LicFobValueForeign;
    if (Number(vVal) < 1) {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter FOB Value (Foreign).";
      return false;
    }
    if (this.LicCifValueINR == undefined || this.LicCifValueINR == null || this.LicCifValueINR == "" || this.LicCifValueINR == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter CIF Value (INR).";
      return false;
    }
    var vVal = this.LicCifValueINR;
    if (Number(vVal) < 1) {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter CIF Value (INR).";
      return false;
    }
    if (this.LicCifValueForeign == undefined || this.LicCifValueForeign == null || this.LicCifValueForeign == "" || this.LicCifValueForeign == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter CIF Value (Foreign).";
      return false;
    }
    var vVal = this.LicCifValueForeign;
    if (Number(vVal) < 1) {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter CIF Value (Foreign).";
      return false;
    }
    if (this.Description == undefined || this.Description == null || this.Description == "" || this.Description == "0") {
      this.Description = "";
    }
    if (this.LicItems == undefined || this.LicItems == null || this.LicItems == [] || this.LicItems.length == 0) {
      this.isShownError = false;
      this.ErrorMsg = "Please Add Atleast One Export Obligation Entry.";
      return false;
    }
    if (this.LicImport == undefined || this.LicImport == null || this.LicImport == [] || this.LicImport.length == 0) {
      this.isShownError = false;
      this.ErrorMsg = "Please Add Atleast One Import Items Sought Entry.";
      return false;
    }

    let params = new HttpParams();
    params = params.append('sNumber', this.LicenseNumber);
    params = params.append('dLicevseDate', this.LicenseDate);
    params = params.append('dValidFrom', this.ValidFrom);
    params = params.append('dValidTo', this.ValidTo);
    params = params.append('sCurrency', this.LicCurrency);
    params = params.append('dValue', this.LicValue);
    params = params.append('sDescription', this.Description);
    params = params.append('iOnboardingId', this.sOnboardingId);
    params = params.append('dLicFobValueForeign', this.LicFobValueForeign);
    params = params.append('dLicCifValueINR', this.LicCifValueINR);
    params = params.append('dLicCifValueForeign', this.LicCifValueForeign);
   //debugger;
    var value = this.http.get(environment.apiUrl + 'LicenseAdm/InsertLicense', { params: params }).toPromise().then(
      (data: any) => {
       //debugger;
        var licId = data;
        this.slicId = licId;

        var licensexpart = this.LicItems;
        for (var i = 0; i < licensexpart.length; i++) {
          var vlicense = licensexpart[i];
          var vitemnum = vlicense.itemnum;
          var vritc = vlicense.ritc;
          var vItemName = vlicense.itemName;
          var vqty = vlicense.quantity;
          var vuom = vlicense.uom;
          var vfobinr = vlicense.fobvalue;
          var vfobfrg = vlicense.fobforeign;
          let params4 = new HttpParams();
          params4 = params4.append('slicId', this.slicId);
          params4 = params4.append('nitemnum', vitemnum);
          params4 = params4.append('nritc', vritc);
          params4 = params4.append('nItemname', vItemName);
          params4 = params4.append('nQty', vqty);
          params4 = params4.append('nuom', vuom);
          params4 = params4.append('nfobInr', vfobinr);
          params4 = params4.append('nfobforgn', vfobfrg);
         //debugger;
          var value = this.http.get(environment.apiUrl + 'LicenseAdm/InsertLicenseExport', { params: params4 }).toPromise().then(
            (data: any) => {
             //debugger;
              var strId1 = data;
              this.sExpId = strId1;
             //debugger;

            })
        }
       //debugger;
        var licensImpart = this.LicImport;
        for (var i = 0; i < licensImpart.length; i++) {
          var vlicenseImp = licensImpart[i];
          var vitemnum = vlicenseImp.itemnum;
          var vritc = vlicenseImp.ritc;
          var vItemName = vlicenseImp.itemName;
          var vbomquantity = vlicenseImp.bomqty;
          var vquantity = vlicenseImp.quantity;
          var vuom = vlicenseImp.uom;
          var vcifvalue = vlicenseImp.cifvalue;
          var vroq = vlicenseImp.roq;
          var vutilQty = vlicenseImp.utilQty;
          var vExptNo = vlicenseImp.licenseExportNo;
          var vImpDutyAmount = vlicenseImp.ImpDutyAmount;
          var vImpCIFvalueForeign = vlicenseImp.ImpCIFvalueForeign;
          let params5 = new HttpParams();
          params5 = params5.append('mlicId', this.slicId);
          params5 = params5.append('sitemnum', vitemnum);
          params5 = params5.append('sritc', vritc);
          params5 = params5.append('sItemname', vItemName);
          params5 = params5.append('sBomQty', vbomquantity);
          params5 = params5.append('sqty', vquantity);
          params5 = params5.append('suom', vuom);
          params5 = params5.append('scifvalue', vcifvalue);
          params5 = params5.append('sroq', vroq);
          params5 = params5.append('sutilqty', vutilQty);
          params5 = params5.append('sExptNo', vExptNo);
          params5 = params5.append('dImpDutyAmount', vImpDutyAmount);
          params5 = params5.append('dImpCIFvalueForeign', vImpCIFvalueForeign);
         //debugger;
          var value = this.http.get(environment.apiUrl + 'LicenseAdm/InsertLicenseImport', { params: params5 }).toPromise().then(
            (data: any) => {
             //debugger;
            })
        }

        var spliturl = this.surl;
       //debugger;
        if (spliturl != undefined && spliturl != "") {
          let params3 = new HttpParams();
          params3 = params3.append('sLicencenseId', this.slicId);
          params3 = params3.append('sfurl', spliturl);
         //debugger;
          var value2 = this.http.get(environment.apiUrl + 'LicenseAdm/InsertLicenseDoc', { params: params3 }).toPromise().then(
            (data: any) => {
              this.LicenseNumber = "";
              this.LicenseDate = "";
              this.ValidFrom = "";
              this.ValidTo = "";
              this.LicCurrency = "";
              this.LicValue = "";
              this.Description = "";
              this.LicFobValueForeign = "";
              this.LicCifValueINR = "";
              this.LicCifValueForeign = "";
              this.ExptNo="0";
              this.Status = true;
              this.isShownSuccess = false;
              this.myFiles = [];
              this.LicItems = [];
              this.LicImport = [];
              this.dataSourceItem = new MatTableDataSource(this.LicItems);
              this.dataSourceItem.data = this.LicItems;
              this.isShowndoclist = true;
              this.dataSourceItem1 = new MatTableDataSource(this.LicImport);
              this.dataSourceItem1.data = this.LicImport;
              this.isShowndoclist = true;
              this.isShownError2 = true;
              this.isShownError3 = true;
              this.selects = [];
              this.surl = "";
              this.SuccessMsg = "License Added.";
              this.BindLicenseGrid();
              this.BindlicenseExport();
              return false;
            }).catch((data: any) => {
             //debugger;
              this.LicenseNumber = "";
              this.LicenseDate = "";
              this.ValidFrom = "";
              this.ValidTo = "";
              this.LicCurrency = "";
              this.LicValue = "";
              this.Description = "";
              this.LicFobValueForeign = "";
              this.LicCifValueINR = "";
              this.LicCifValueForeign = "";
              this.Status = true;
              this.myFiles = [];
              this.selects = [];
              this.LicItems = [];
              this.LicImport = [];
              this.surl = "";
              this.isShownError2 = true;
              this.isShownError3 = true;
              this.dataSourceItem = new MatTableDataSource(this.LicItems);
              this.dataSourceItem.data = this.LicItems;
              this.isShowndoclist = true;
              this.dataSourceItem1 = new MatTableDataSource(this.LicImport);
              this.dataSourceItem1.data = this.LicImport;
              this.isShowndoclist = true;
              this.isShownSuccess = false;
              this.SuccessMsg = "License Added.";
              this.BindLicenseGrid();
              this.BindlicenseExport();
              return false;
            })
        }
        else {
          this.LicenseNumber = "";
          this.LicenseDate = "";
          this.ValidFrom = "";
          this.ValidTo = "";
          this.LicCurrency = "";
          this.LicValue = "";
          this.Description = "";
          this.LicFobValueForeign = "";
          this.LicCifValueINR = "";
          this.LicCifValueForeign = "";
          this.Status = true;
          this.myFiles = [];
          this.selects = [];
          this.LicItems = [];
          this.LicImport = [];
          this.surl = "";
          this.isShownError2 = true;
          this.isShownError3 = true;
          this.dataSourceItem = new MatTableDataSource(this.LicItems);
          this.dataSourceItem.data = this.LicItems;
          this.isShowndoclist = true;
          this.dataSourceItem1 = new MatTableDataSource(this.LicImport);
          this.dataSourceItem1.data = this.LicImport;
          this.isShowndoclist = true;
          this.isShownSuccess = false;
          this.SuccessMsg = "License Added.";
          this.BindLicenseGrid();
          this.BindlicenseExport();
        }
      }).catch((data: any) => {
       //debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
        else if (vErrorMsg1 == "Exist") {
          this.isShownError = false;
          this.ErrorMsg = "License Number, Already Exists.";
          return false;
        }
        else {
        }
      });

  }

  Editlicdet(item: any) {
    this.isShownSaveBtn = true;
    this.isShownUpdateBtn = false;
    this.isShownActive = false;
    this.Status = true;
    this.isShownSuccess = true;
    this.isShownError = true;
    this.SuccessMsg = "";
    this.ErrorMsg = "";
    this.Editedlicense = item;
   //debugger;

    var vtype = this.Editedlicense.type;
    var vnumber = this.Editedlicense.number;
    var vlicenseDate = this.Editedlicense.licenseDate;
    var vvalidFrom = this.Editedlicense.validFrom;
    var vvalidTo = this.Editedlicense.validTo;
    var vcurrency = this.Editedlicense.currency;
    var vvalue = this.Editedlicense.value;
    var vdescription = this.Editedlicense.description;
    var vstatus = this.Editedlicense.status;
    var vlicenseinfoid = this.Editedlicense.licenseinfoid;
    var vlicFobValueForeign = this.Editedlicense.licFobValueForeign;
    var vlicCifValueINR = this.Editedlicense.licCifValueINR;
    var vlicCifValueForeign = this.Editedlicense.licCifValueForeign;

   debugger;
    this.EditedlicenseId = vlicenseinfoid;
    this.Editedlicensetype = vtype;
    this.LicenseNumber = vnumber;
    this.LicenseDate = new Date(new Date(vlicenseDate).setDate(new Date(vlicenseDate).getDate() + 1)).toISOString().split('T')[0];
    this.ValidFrom = new Date(new Date(vvalidFrom).setDate(new Date(vvalidFrom).getDate() + 1)).toISOString().split('T')[0];
    this.ValidTo = new Date(new Date(vvalidTo).setDate(new Date(vvalidTo).getDate() + 1)).toISOString().split('T')[0];
    this.LicCurrency = vcurrency;
    this.LicValue = vvalue;
    this.Description = vdescription;
    this.LicFobValueForeign=vlicFobValueForeign;
    this.LicCifValueINR=vlicCifValueINR;
    this.LicCifValueForeign=vlicCifValueForeign;
    if (vstatus == "Active") {
      this.Status = false;
    }
    else {
      this.Status = true;
    }
   //debugger;

    var value5 = this.http.get(environment.apiUrl + 'LicenseAdm/GetlicExportForEdit?licId=' + vlicenseinfoid).toPromise().then(
      (data: any) => {
       //debugger;
        if ((data.length != 0)) {
          var vData2 = data;
          this.dataSourceItem = new MatTableDataSource(vData2);
          this.dataSourceItem.data = vData2;
          this.dataSourceItem.paginator = this.tableItemPaginator;
          this.dataSourceItem.sort = this.tableItemSort;
          this.LicItems = [];
          this.LicItems = data;
        }
      });

    var value7 = this.http.get(environment.apiUrl + 'LicenseAdm/GetlicImportForEdit?licId=' + vlicenseinfoid).toPromise().then(
      (data: any) => {
       //debugger;
        if ((data.length != 0)) {
          var vData3 = data;
          this.dataSourceItem1 = new MatTableDataSource(vData3);
          this.dataSourceItem1.data = vData3;
          this.dataSourceItem1.paginator = this.tableItemPaginator1;
          this.dataSourceItem1.sort = this.tableItemSort1;
        }
        
      });

    this.selects = [];
    var value3 = this.http.get(environment.apiUrl + 'LicenseAdm/GetDocForEdit?licId=' + vlicenseinfoid).toPromise().then(
      (data: any) => {
       //debugger;
        if (data.length != 0) {
          var vData1 = data;
         //debugger;
          for (var i = 0; i < vData1.length; i++) {
            this.EditedDoc = vData1[i];
            var vdocId = this.EditedDoc.ldocId;
            var vdocurl = this.EditedDoc.docUrl;
            var furl = vdocurl;
            this.isShownimage = false;
            this.isShowndoclist = false;
            var cvname = furl.split("/");
            var fname = cvname[6];
            this.selects.push({ docid: vdocId, filename: fname, fileURL: furl });
            // this.updatedocid.push({ updocid: vdocId, upfileurl: furl });
            //var fdocid = this.updatedocid;                 
          }
        }
      });
  }

  EditExplicense(item: any) {
    this.isShownadBtn = true;
    this.isShownupdBtn = false;
    this.isShownActive = false;
    //this.Status = true;
    this.isShownSuccess = true;
    this.isShownError = true;
    this.isShownSuccess2 = true;
    this.isShownError2 = true;
    this.isShownSuccess3 = true;
    this.isShownError3 = true;
    this.SuccessMsg = "";
    this.ErrorMsg = "";
    this.EditedlicenseExport = item;
   //debugger;
    var vitemnum = this.EditedlicenseExport.itemnum;
    var vitemname = this.EditedlicenseExport.itemName;
    var vritc = this.EditedlicenseExport.ritc;
    var vquantity = this.EditedlicenseExport.quantity;
    var vuom = this.EditedlicenseExport.uom;
    var vfobvalue = this.EditedlicenseExport.fobvalue;
    var vfobforeign = this.EditedlicenseExport.fobforeign;
    var vlicenseInfoId = this.EditedlicenseExport.licenseInfoId;
    var vlicexpId = this.EditedlicenseExport.licexpId;
   //debugger;

    this.ExpItemNo = vitemnum;
    this.ExportRitc = vritc;
    this.ExpItemName = vitemname;
    this.ExpQuantity = vquantity;
    this.ExpUOM = vuom;
    this.ExpFobInr = vfobvalue;
    this.ExpFobForgn = vfobforeign;
    this.EditedlicenseId = vlicenseInfoId;
    this.EditedlicenseExportId = vlicexpId;
  }

  Editimportlicense(item: any) {
    this.isShownadBtn1 = true;
    this.isShownupdBtn1 = false;
    this.isShownActive = false;
    //this.Status = true;
    this.isShownSuccess = true;
    this.isShownError = true;
    this.isShownSuccess2 = true;
    this.isShownError2 = true;
    this.isShownSuccess3 = true;
    this.isShownError3 = true;
    this.SuccessMsg = "";
    this.ErrorMsg = "";
    this.EditedlicenseImport = item;
   //debugger;
    var vitemno = this.EditedlicenseImport.itemnum;
    var vritc = this.EditedlicenseImport.ritc;
    var vitemName = this.EditedlicenseImport.itemName;
    var vbomqty = this.EditedlicenseImport.bomqty;
    var vquantity = this.EditedlicenseImport.quantity;
    var vuom = this.EditedlicenseImport.uom;
    var vcifvalue = this.EditedlicenseImport.cifvalue;
    var vroq = this.EditedlicenseImport.roq;
    var vutilQty = this.EditedlicenseImport.utilQty;
    var vImpDutyAmount = this.EditedlicenseImport.impDutyAmount;
    var vImpCIFvalueForeign = this.EditedlicenseImport.impCIFvalueForeign;
    //var vlicenseInfoId = this.EditedlicenseImport.licexpId;
    var vlicimprtId = this.EditedlicenseImport.licimportid;
   //debugger;

    this.ImpItemNo = vitemno;
    this.ImpRitc = vritc;
    this.ImpItemName = vitemName;
    this.ImpBOMquantity = vbomqty;
    this.ImpQuantity = vquantity;
    this.ImpUOM = vuom;
    this.ImpCIFvalue = vcifvalue;
    this.ImpROQ = vroq;
    this.ImpUtilQty = vutilQty;
    this.ImpDutyAmount=vImpDutyAmount;
    this.ImpCIFvalueForeign=vImpCIFvalueForeign;
    //this.EditedlicenseId = vlicenseInfoId;
    this.EditedlicenseImportId = vlicimprtId;
    this.ExptNo = this.EditedlicenseImport.licenseExportNo;
  }

  btnlicupdate() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.isShownActive = false;

    if (this.LicenseNumber == undefined || this.LicenseNumber == null || this.LicenseNumber == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter License Number.";
      return false;
    }
    if (this.LicenseDate == undefined || this.LicenseDate == null || this.LicenseDate == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter License Date.";
      return false;
    }
    if (this.ValidFrom == undefined || this.ValidFrom == null || this.ValidFrom == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid From.";
      return false;
    }
    if (this.ValidTo == undefined || this.ValidTo == null || this.ValidTo == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid To.";
      return false;
    }
    if (this.ValidFrom > this.ValidTo) {
      this.isShownError = false;
      this.ErrorMsg = "Valid To Date Should be Geater Then or EqualTo Valid From Date.";
      return false;
    }
    if (this.LicCurrency == undefined || this.LicCurrency == null || this.LicCurrency == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Currency.";
      return false;
    }
    if (this.LicValue == undefined || this.LicValue == null || this.LicValue == "" || this.LicValue == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter FOB Value (INR).";
      return false;
    }
    var vVal = this.LicValue;
    if (Number(vVal) < 1) {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid FOB Value (INR).";
      return false;
    }
    if (this.LicFobValueForeign == undefined || this.LicFobValueForeign == null || this.LicFobValueForeign == "" || this.LicFobValueForeign == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter FOB Value (Foreign).";
      return false;
    }
    var vVal = this.LicFobValueForeign;
    if (Number(vVal) < 1) {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid FOB Value (Foreign).";
      return false;
    }
    if (this.LicCifValueINR == undefined || this.LicCifValueINR == null || this.LicCifValueINR == "" || this.LicCifValueINR == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter CIF Value (INR).";
      return false;
    }
    var vVal = this.LicCifValueINR;
    if (Number(vVal) < 1) {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid CIF Value (INR).";
      return false;
    }
    if (this.LicCifValueForeign == undefined || this.LicCifValueForeign == null || this.LicCifValueForeign == "" || this.LicCifValueForeign == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter CIF Value (Foreign).";
      return false;
    }
    var vVal = this.LicCifValueForeign;
    if (Number(vVal) < 1) {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid CIF Value (Foreign).";
      return false;
    }
    if (this.Description == undefined || this.Description == null || this.Description == "" || this.Description == "0") {
      this.Description = "";
    }
    var vStatus = "Active";
    if (this.Status == true)
      vStatus = "InActive";
    else
      vStatus = "Active";
   //debugger;
    let params = new HttpParams();
    params = params.append('dtype', this.Editedlicensetype);
    params = params.append('dNumber', this.LicenseNumber);
    params = params.append('dLicevseDate', this.LicenseDate);
    params = params.append('dValidFrom', this.ValidFrom);
    params = params.append('dValidTo', this.ValidTo);
    params = params.append('dCurrency', this.LicCurrency);
    params = params.append('dValue', this.LicValue);
    params = params.append('dDescription', this.Description);    
    params = params.append('dlicId', this.EditedlicenseId);
    params = params.append('dstatus', vStatus);    
    params = params.append('dLicFobValueForeign', this.LicFobValueForeign);
    params = params.append('dLicCifValueINR', this.LicCifValueINR);
    params = params.append('dLicCifValueForeign', this.LicCifValueForeign);
    var value = this.http.get(environment.apiUrl + 'LicenseAdm/UpdateLicense', { params: params }).toPromise().then(
      (data: any) => {
       //debugger;
      }).catch((data: any) => {
       //debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Success") {
          var licid = this.EditedlicenseId;
          var spliturl = this.surl;
         //debugger;
          if (spliturl != undefined && spliturl != "") {
            let params3 = new HttpParams();
            params3 = params3.append('sLicencenseId', licid);
            params3 = params3.append('sfurl', spliturl);
           //debugger;
            var value2 = this.http.get(environment.apiUrl + 'LicenseAdm/InsertLicenseDoc', { params: params3 }).toPromise().then(
              (data: any) => {
                this.isShownActive = true;
                this.isShownSaveBtn = false;
                this.isShownUpdateBtn = true;
                this.LicType = "0";
                this.LicenseNumber = "";
                this.LicenseDate = "";
                this.ValidFrom = "";
                this.ValidTo = "";
                this.LicCurrency = "";
                this.LicValue = "";
                this.Description = "";
                this.LicFobValueForeign = "";
              this.LicCifValueINR = "";
              this.LicCifValueForeign = "";
                this.Status = true;
                this.isShownSuccess = false;
                this.myFiles = [];
                this.selects = [];
                this.LicItems = [];
                this.surl = "";
                this.dataSourceItem = new MatTableDataSource(this.LicItems);
                this.dataSourceItem.data = this.LicItems;
                this.isShowndoclist = true;
                this.isShownSuccess = false;
                this.EditedlicenseId="0";
                this.SuccessMsg = "License Updated.";
                this.BindLicenseGrid();
                this.BindlicenseExport();
                return false;
              }).catch((data: any) => {
               //debugger;
                this.isShownActive = true;
                this.isShownSaveBtn = false;
                this.isShownUpdateBtn = true;
                this.LicType = "0";
                this.LicenseNumber = "";
                this.LicenseDate = "";
                this.ValidFrom = "";
                this.ValidTo = "";
                this.LicCurrency = "";
                this.LicValue = "";
                this.Description = "";
                this.LicFobValueForeign = "";
              this.LicCifValueINR = "";
              this.LicCifValueForeign = "";
                this.Status = true;
                this.myFiles = [];
                this.selects = [];
                this.LicItems = [];
                this.surl = "";
                this.EditedlicenseId="0";
                this.dataSourceItem = new MatTableDataSource(this.LicItems);
                this.dataSourceItem.data = this.LicItems;
                this.isShowndoclist = true;
                this.isShownSuccess = false;
                this.SuccessMsg = "License Updated.";
                this.BindLicenseGrid();
                this.BindlicenseExport();
                return false;
              })
          }
          else {
            this.isShownActive = true;
            this.isShownSaveBtn = false;
            this.isShownUpdateBtn = true;
            this.LicType = "0";
            this.LicenseNumber = "";
            this.LicenseDate = "";
            this.ValidFrom = "";
            this.ValidTo = "";
            this.LicCurrency = "";
            this.LicValue = "";
            this.Description = "";
            this.LicFobValueForeign = "";
              this.LicCifValueINR = "";
              this.LicCifValueForeign = "";
            this.Status = true;
            this.isShownSuccess = false;
            this.EditedlicenseId="0";
            this.myFiles = [];
            this.selects = [];
            this.LicItems = [];
            this.surl = "";
            this.dataSourceItem = new MatTableDataSource(this.LicItems);
            this.dataSourceItem.data = this.LicItems;
            this.isShowndoclist = true;
            this.SuccessMsg = "License Updated.";
            this.BindLicenseGrid();
            this.BindlicenseExport();
            return false;
          }
        }
        else {
          this.isShownError = false;
          this.ErrorMsg = "Update Failed, Please Try Again.";
          return false;
        }
      });
  }

  btnExpUpdateClick() {
    var editedlicId = this.EditedlicenseId;
    var editedlicExportId = this.EditedlicenseExportId;
   //debugger;
    if (this.ExpItemNo == undefined || this.ExpItemNo == null || this.ExpItemNo == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Export Item Number.";
      return false;
    }
    if (this.ExportRitc == undefined || this.ExportRitc == null || this.ExportRitc == "" || this.ExportRitc == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Export RITC Code.";
      return false;
    }
    if (this.ExpItemName == undefined || this.ExpItemName == null || this.ExpItemName == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Export Item Name.";
      return false;
    }
    if (this.ExpQuantity == undefined || this.ExpQuantity == null || this.ExpQuantity == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Export Quantity.";
      return false;
    }
    if (this.ExpUOM == undefined || this.ExpUOM == null || this.ExpUOM == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Export UOM.";
      return false;
    }
    if (this.ExpFobInr == undefined || this.ExpFobInr == null || this.ExpFobInr == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Export FOB(INR).";
      return false;
    }
    if (this.ExpFobForgn == undefined || this.ExpFobForgn == null || this.ExpFobForgn == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Export FOB Foreign.";
      return false;
    }
    var vUnitPrice = this.ExpFobInr;
    if (Number(vUnitPrice) < 1) {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid Export Fob(INR).";
      return false;
    }
    var vItemQuantity = this.ExpQuantity;
    if (Number(vItemQuantity) < 1) {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid Export Item Quantity.";
      return false;
    }

   //debugger;
    let params4 = new HttpParams();
    params4 = params4.append('slicId', editedlicId);
    params4 = params4.append('sExplicId', editedlicExportId);
    params4 = params4.append('nitemnum', this.ExpItemNo);
    params4 = params4.append('nritc', this.ExportRitc);
    params4 = params4.append('nItemname', this.ExpItemName);
    params4 = params4.append('nQty', this.ExpQuantity);
    params4 = params4.append('nuom', this.ExpUOM);
    params4 = params4.append('nfobInr', this.ExpFobInr);
    params4 = params4.append('nfobforgn', this.ExpFobForgn);
   //debugger;
    var value3 = this.http.get(environment.apiUrl + 'LicenseAdm/UpdateLicenseExport', { params: params4 }).toPromise().then(
      (data: any) => {
        var vmsg = data;
        this.BindLicenseExportGrid();
        this.ExpItemNo = "";
        this.ExportRitc = "";
        this.ExpItemName = "";
        this.ExpQuantity = "";
        this.ExpUOM = "NUM";
        this.ExpFobInr = "";
        this.ExpFobForgn = "";
        this.isShownSuccess3 = true;
        this.isShownError3 = true;
        this.isShownadBtn = false;
        this.isShownupdBtn = true;
      }).catch((data: any) => {
        var vmsg = data;
        this.BindLicenseExportGrid();
        this.ExpItemNo = "";
        this.ExportRitc = "";
        this.ExpItemName = "";
        this.ExpQuantity = "";
        this.ExpUOM = "NUM";
        this.ExpFobInr = "";
        this.ExpFobForgn = "";
        this.isShownSuccess3 = true;
        this.isShownError3 = true;
        this.isShownadBtn = false;
        this.isShownupdBtn = true;
      });
  }

  btnImpupdClick() {
    var editedlicId = this.EditedlicenseId;
    var editedlicimportId = this.EditedlicenseImportId;
   //debugger;
    if (this.ImpItemNo == undefined || this.ImpItemNo == null || this.ImpItemNo == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Import Item Number.";
      return false;
    }
    if (this.ImpRitc == undefined || this.ImpRitc == null || this.ImpRitc == "" || this.ImpRitc == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Import RITC Code.";
      return false;
    }
    if (this.ImpItemName == undefined || this.ImpItemName == null || this.ImpItemName == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Import Item Name.";
      return false;
    }
    if (this.ImpBOMquantity == undefined || this.ImpBOMquantity == null || this.ImpBOMquantity == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Import BOM Quantity.";
      return false;
    }
    if (this.ImpQuantity == undefined || this.ImpQuantity == null || this.ImpQuantity == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Import Quantity.";
      return false;
    }
    if (this.ImpUOM == undefined || this.ImpUOM == null || this.ImpUOM == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter UOM.";
      return false;
    }
    if (this.ImpCIFvalue == undefined || this.ImpCIFvalue == null || this.ImpCIFvalue == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter CIF value.";
      return false;
    }
    var vImpROQ=this.ImpROQ.toString();
    if (vImpROQ == undefined || vImpROQ == null || vImpROQ == "") {      
      this.isShownError2 = false;
      this.ErrorMsg = "Please Enter ROQ.";
      return false;
    }
    // if (this.ImpDutyAmount == undefined || this.ImpDutyAmount == null || this.ImpDutyAmount == "") {
    //   this.isShownError2 = false;
    //   this.ErrorMsg = "Please Enter Duty Amount.";
    //   return false;
    // }
    if (this.ImpCIFvalueForeign == undefined || this.ImpCIFvalueForeign == null || this.ImpCIFvalueForeign == "") {
      this.isShownError2 = false;
      this.ErrorMsg = "Please Enter CIF Value Foreign.";
      return false;
    }
    // if (this.ImpUtilQty == undefined || this.ImpUtilQty == null || this.ImpUtilQty == "") {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Enter Utilized Quantity.";
    //   return false;
    // }

   //debugger;
    let params7 = new HttpParams();
    params7 = params7.append('mlicId', editedlicId);
    params7 = params7.append('mlicImportId', editedlicimportId);
    params7 = params7.append('sitemnum', this.ImpItemNo);
    params7 = params7.append('sritc', this.ImpRitc);
    params7 = params7.append('sItemname', this.ImpItemName);
    params7 = params7.append('sBomQty', this.ImpBOMquantity);
    params7 = params7.append('sqty', this.ImpQuantity);
    params7 = params7.append('suom', this.ImpUOM);
    params7 = params7.append('scifvalue', this.ImpCIFvalue);
    params7 = params7.append('sroq', this.ImpROQ);
    params7 = params7.append('sutilqty', this.ImpUtilQty);
    params7 = params7.append('dImpDutyAmount', this.ImpDutyAmount);
    params7 = params7.append('dImpCIFvalueForeign', this.ImpCIFvalueForeign);
   //debugger;
    var value3 = this.http.get(environment.apiUrl + 'LicenseAdm/UpdateLicenseImport', { params: params7 }).toPromise().then(
      (data: any) => {
        var vmsg = data;
        this.ImpItemNo = "";
        this.ImpRitc = "";
        this.ImpItemName = "";
        this.ImpBOMquantity = "";
        this.ImpQuantity = "";
        this.ImpUOM = "NUM";
        this.ImpCIFvalue = "";
        this.ImpROQ = "";
        this.ImpUtilQty = "0";
        this.ImpDutyAmount="0";
        this.ImpCIFvalueForeign="";
        this.ExptNo="0";
        this.isShownSuccess2 = true;
        this.isShownError2 = true;
        this.isShownadBtn1 = false;
        this.isShownupdBtn1 = true;
        this.BindLicenseImportGrid();

      }).catch((data: any) => {
        var vmsg = data;
        this.ImpItemNo = "";
        this.ImpRitc = "";
        this.ImpItemName = "";
        this.ImpBOMquantity = "";
        this.ImpQuantity = "";
        this.ImpUOM = "";
        this.ImpCIFvalue = "";
        this.ImpROQ = "";
        this.ImpUtilQty = "0";
        this.ImpDutyAmount="0";
        this.ImpCIFvalueForeign="";
        this.ExptNo="0";
        this.isShownSuccess2 = true;
        this.isShownError2 = true;
        this.isShownadBtn1 = false;
        this.isShownupdBtn1 = true;
        this.BindLicenseImportGrid();

      });
  }

  btnlicclear() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownActive = true;
    this.isShownSaveBtn = false;
    this.isShownUpdateBtn = true;
    this.SuccessMsg = "";
    this.ErrorMsg = "";
    this.LicenseNumber = "";
    this.LicenseDate = "";
    this.ValidFrom = "";
    this.ValidTo = "";
    this.LicCurrency = "";
    this.LicValue = "";
    this.Description = "";
    this.LicFobValueForeign = "";
              this.LicCifValueINR = "";
              this.LicCifValueForeign = "";
              this.ExpUOM="NUM";
    this.ImpUOM="NUM";
    this.Status = true;
    this.myFiles = [];
    this.selects = [];
    this.LicItems = [];
    this.LicImport = [];
    this.surl = "";
    this.EditedlicenseId="0";
    this.dataSourceItem = new MatTableDataSource(this.LicItems);
    this.dataSourceItem.data = this.LicItems;
    this.isShowndoclist = true;
    this.dataSourceItem1 = new MatTableDataSource(this.LicImport);
    this.dataSourceItem1.data = this.LicImport;
    this.isShowndoclist = true;
  }

  btnimppartclear() {
    this.ImpItemNo = "";
    this.ImpRitc = "";
    this.ImpItemName = "";
    this.ImpBOMquantity = "";
    this.ImpQuantity = "";
    this.ImpUOM = "NUM";
    this.ImpCIFvalue = "";
    this.ImpROQ = "";
    this.ImpUtilQty = "0";
    this.ImpDutyAmount="0";
    this.ImpCIFvalueForeign="";
    this.isShownSuccess2 = true;
    this.isShownError2 = true;
    this.isShownadBtn1 = false;
    this.isShownupdBtn1 = true;
  }

  btnexportclear() {
    this.ExpItemNo = "";
    this.ExportRitc = "";
    this.ExpItemName = "";
    this.ExpQuantity = "";
    this.ExpUOM = "NUM";
    this.ExpFobInr = "";
    this.ExpFobForgn = "";
    this.isShownSuccess3 = true;
    this.isShownError3 = true;
    this.isShownadBtn = false;
    this.isShownupdBtn = true;
  }

  BindLicenseGrid() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    var vtype = "AAS";
    let params = new HttpParams();
    params = params.append('dtype', vtype);
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'LicenseAdm/GetLicenseForGrid', { params: params }).toPromise().then(
      (data1: any) => {
        //debugger;
        this.dataSource1 = new MatTableDataSource(data1);
        this.dataSource1.data = data1;
        this.dataSource1.paginator = this.paginator1;
        this.dataSource1.sort = this.sort1;
      });
  }

  BindLicensepartGrid() {
    
    var editedlicId = this.EditedlicenseId
    var value5 = this.http.get(environment.apiUrl + 'LicenseAdm/GetlicExportForEdit?licId=' + editedlicId).toPromise().then(
      (data1: any) => {
       //debugger;
        this.dataSourceItem = new MatTableDataSource(data1);
        this.dataSourceItem.data = data1;
        this.dataSourceItem.paginator = this.tableItemPaginator;
        this.dataSourceItem.sort = this.tableItemSort;
        this.LicItems = [];
          this.LicItems = data1;
      });
  }

  BindLicenseExportGrid() {
    var editedlicId = this.EditedlicenseId
    var value5 = this.http.get(environment.apiUrl + 'LicenseAdm/GetlicExportForEdit?licId=' + editedlicId).toPromise().then(
      (data1: any) => {
        //debugger;
        this.dataSourceItem = new MatTableDataSource(data1);
        this.dataSourceItem.data = data1;
        this.dataSourceItem.paginator = this.tableItemPaginator;
        this.dataSourceItem.sort = this.tableItemSort;
      });
  }

  BindLicenseImportGrid() {
    var editedlicId = this.EditedlicenseId
    var value7 = this.http.get(environment.apiUrl + 'LicenseAdm/GetlicImportForEdit?licId=' + editedlicId).toPromise().then(
      (data1: any) => {
       //debugger;
        this.dataSourceItem1 = new MatTableDataSource(data1);
        this.dataSourceItem1.data = data1;
        this.dataSourceItem1.paginator = this.tableItemPaginator1;
        this.dataSourceItem1.sort = this.tableItemSort1;
      });
  }

  applyFilter(filterValue: string) {
   //debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource1.filter = filterValue;
  }

  BindlicenseExport() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    let params = new HttpParams();
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'LicenseAdm/GetLicenseForExport',{params : params}).toPromise().then(
      (data: any) => {
       ////debugger;
        this.licenseaasExport = data;
      });
  }


  exportexcel(): void {
   //debugger;
    /* table id is passed over here */
    const workSheet = XLSX.utils.json_to_sheet(this.licenseaasExport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, workSheet, 'licenseAAS');

    /* save to file */
    XLSX.writeFile(wb, "license-AAS.xlsx");

  }
  
  ddlExportNoChange(event: any) {
   //debugger;
   var vExptNo=event.target.value;    
   var vLicImport = this.LicItems;
   for (var i = 0; i < vLicImport.length; i++) {
     var vlicenseExport = vLicImport[i];
     var vitemnum = vlicenseExport.itemnum;
     if(vExptNo==vitemnum)
     {
       var vquantity=vlicenseExport.quantity;
       this.ImpQuantity=vquantity;
       this.ImpBOMquantity=vquantity;
     }
   }
  }

  RemoveDocument(item: any,index) {

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to remove this File!',

      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
        this.selects.splice(index,1);
        if(item.docid == undefined)
{
  let params = new HttpParams();
    params = params.append('lDocumentId', item.docid);
    var value = this.http.get(environment.apiUrl + 'LicenseAdm/DeleteFromLicenseInfoDoc', { params: params }).toPromise().then(
      (data: any) => {
       
        var returnValue = data;
        return false;
      }).catch((data: any) => {
        
        var vDataError = JSON.stringify(data.error.text);
       
              var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Delete Failed, Please Try Again.";
          return false;
        }
        else if(vErrorMsg1 == "Success")
        {
          
          return false;
  
        }

  


  });
}

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        
      }
    })
     
  

  }


}
